import { render, staticRenderFns } from "./recruiter-login.vue?vue&type=template&id=64cab3c0&scoped=true"
import script from "./recruiter-login.vue?vue&type=script&lang=js"
export * from "./recruiter-login.vue?vue&type=script&lang=js"
import style0 from "./recruiter-login.vue?vue&type=style&index=0&id=64cab3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cab3c0",
  null
  
)

export default component.exports